export const SKILLS =[
    {
        id: 0,
        image: 'assets/images/skill/html.svg',
        name:'HTML'
    },
    {
        id: 1,
        image: 'assets/images/skill/css.svg',
        name:'CSS'
    },
    {
        id: 2 ,
        image: 'assets/images/skill/bootstrap.png',
        name:'Bootstrap'
    },
    {
        id: 3,
        image: 'assets/images/skill/javascript.png',
        name:'Javascript'
    },
    {
        id: 4,
        image: 'assets/images/skill/react.svg',
        name:'React JS',

    },
    {
        id: 5,
        image: 'assets/images/skill/sql.png',
        name: 'SQL'
    },
    {
        id: 6,
        image: 'assets/images/skill/nodejs.svg',
        name:'Node JS'
    },
    {
        id: 7,
        image: 'assets/images/skill/vercel.svg',
        name:'Vercel'
    },
    {
        id: 8,
        image: 'assets/images/skill/netlify.svg',
        name: 'Netlify'
    },
    {
        id: 9,
        image:'assets/images/skill/tailwindcss.svg',
        name: 'Tailwind'
        
    },
    {
        id: 10,
        image:'assets/images/skill/redux.svg',
        name: 'Redux'
        
    },
    {
        id: 9,
        image:'assets/images/skill/mongodb.svg',
        name: 'Mongo DB'
        
    },
    {
        id: 10,
        image:'assets/images/skill/Java.svg',
        name: 'Java'
        
    },
]
export const CONTENTS=[

{
    id:0,
    substance:'Experience in using JavaScript (ES6), HTML5, CSS3.'
},
{
    id:1,
    substance:'Responsive web pages with React, Bootstrap'
 
},
{
    id:2,
    substance:'Deployment to platforms such as Vercel, Netlify'

},
{
    id:3,
    substance:'Basic level with NodeJS, Java, MongoDB'
},
{
    id:4,
    substance:'Soft skills: Sense of responsibility, communication skills, and team spirit.'
},
{
    id:5,
    substance:'Furthermore, I am willingness to learn new knowledge and skills from internship'
}
]